// Global styles - must be loaded first
import "@styles/_reset.sass";
import "@styles/css-variables/_index.sass";
import "@styles/utilities/_index.sass";

import Initializer from "./main/initializer.js";

new Initializer();
